module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/pathway-48f0f7d0a918b239ee4990b9459468e2.svg";